import { FormStatus, formStatusPrefix, getDisplayValue } from '@assess/shared/ontology-types';

import { ReasonCodeEntityClass, ReasonCodePrimaryType } from './reason-code-type.enums';
import { IReasonCodeGroupConfig, IReasonCodeType } from './reason-code-type.interfaces';

export class StatusType implements IReasonCodeType {
  readonly entityClass = ReasonCodeEntityClass.ProgramPeriod;
  readonly primaryType = ReasonCodePrimaryType.FormStatusReason;

  constructor(readonly config: IReasonCodeGroupConfig) {}
}

const FormOpenReason = new StatusType({
  secondaryType: FormStatus.Open,
  statusLabel: getDisplayValue(FormStatus.Open, formStatusPrefix),
  isDefault: true,
  maxReasonCodeCount: 1,
});

const FormInProgressReason = new StatusType({
  secondaryType: FormStatus.InProgress,
  statusLabel: getDisplayValue(FormStatus.InProgress, formStatusPrefix),
  isDefault: true,
});

const FormReadyToSubmitReason = new StatusType({
  secondaryType: FormStatus.ReadyToSubmit,
  statusLabel: getDisplayValue(FormStatus.ReadyToSubmit, formStatusPrefix),
  isDefault: true,
  maxReasonCodeCount: 1,
});

const FormSubmittedReason = new StatusType({
  secondaryType: FormStatus.Submitted,
  statusLabel: getDisplayValue(FormStatus.Submitted, formStatusPrefix),
  isDefault: true,
});

const FormReturnedReason = new StatusType({
  secondaryType: FormStatus.Returned,
  statusLabel: getDisplayValue(FormStatus.Returned, formStatusPrefix),
  isDefault: true,
});

const FormReadyToResubmitReason = new StatusType({
  secondaryType: FormStatus.ReadyToResubmit,
  statusLabel: getDisplayValue(FormStatus.ReadyToResubmit, formStatusPrefix),
  isDefault: true,
  maxReasonCodeCount: 1,
});

const FormApprovedReason = new StatusType({
  secondaryType: FormStatus.Approved,
  statusLabel: getDisplayValue(FormStatus.Approved, formStatusPrefix),
  isDefault: true,
});

const FormRejectedReason = new StatusType({
  secondaryType: FormStatus.Rejected,
  statusLabel: getDisplayValue(FormStatus.Rejected, formStatusPrefix),
  isDefault: true,
});

const FormInReviewReason = new StatusType({
  secondaryType: FormStatus.InReview,
  statusLabel: getDisplayValue(FormStatus.InReview, formStatusPrefix),
  isDefault: true,
});

const FormCancelledReason = new StatusType({
  secondaryType: FormStatus.Cancelled,
  statusLabel: getDisplayValue(FormStatus.Cancelled, formStatusPrefix),
  isDefault: true,
});

const FormReopenedReason = new StatusType({
  secondaryType: FormStatus.FormReopened,
  statusLabel: getDisplayValue(FormStatus.FormReopened, formStatusPrefix),
  isDefault: true,
  maxReasonCodeCount: 1,
});

export const FormStatusReason = [
  FormOpenReason,
  FormInProgressReason,
  FormReadyToSubmitReason,
  FormSubmittedReason,
  FormInReviewReason,
  FormReturnedReason,
  FormReadyToResubmitReason,
  FormApprovedReason,
  FormRejectedReason,
  FormReopenedReason,
  FormCancelledReason,
];
